// Display-only relabelling of article codes that mean nothing to a shop on their
// own. Keys are matched trimmed and case-insensitively; anything unknown is
// returned unchanged.
//
// Presentation only. Never feed the result back into a request or into an
// editable input — the stored article name has to stay exactly what the backend
// sent, so this belongs in plain-text renders only.
const ARTICLE_DISPLAY_NAMES: Record<string, string> = {
  CM1698: "CM1698 (75 inch frame)",
  CM1699: "CM1699 (65 inch frame)",
};

export default function formatArticleName(
  articleName?: string | null
): string {
  if (!articleName) return "";
  return ARTICLE_DISPLAY_NAMES[articleName.trim().toUpperCase()] ?? articleName;
}
